import { render, staticRenderFns } from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=template&id=64d443ba"
import script from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=script&lang=js"
export * from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=script&lang=js"
import style0 from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=style&index=0&id=64d443ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports